module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/908d56ed296646a03e814f80db74bd77.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/badges/Epic/Epic0.svg
// module id = pxdW
// module chunks = 1